import { apiPost } from "./client";

export const contactApi = {
  submit: (data) => apiPost("/api/contact", data),
};
